"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function () {
  var _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect,
    useRef = _React.useRef;
  var InvBtn = function InvBtn(_ref) {
    var label = _ref.label,
      icon = _ref.icon,
      onClick = _ref.onClick,
      loading = _ref.loading;
    var _window = window,
      Lucide = _window.Lucide;
    return /*#__PURE__*/React.createElement("button", {
      onClick: onClick,
      disabled: loading,
      className: "flex flex-col items-center justify-center p-1 md:p-2 bg-slate-900 hover:bg-slate-800 border-r border-slate-800 last:border-0 text-slate-400 hover:text-sky-400 hover:bg-slate-800/50 transition-all flex-1 disabled:opacity-50 disabled:cursor-wait group"
    }, loading ? /*#__PURE__*/React.createElement(Lucide, {
      icon: "loader-2",
      className: "w-5 h-5 md:w-6 md:h-6 animate-spin mb-1"
    }) : /*#__PURE__*/React.createElement(Lucide, {
      icon: icon,
      className: "w-5 h-5 md:w-6 md:h-6 mb-1 text-slate-400 group-hover:text-sky-400 transition-colors"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-[9px] md:text-[10px] font-bold uppercase tracking-wider"
    }, label));
  };

  // =========================================================================================
  // THE BLOOD GAS, AS THE ANALYSER PRINTS IT (Jake, 15 Oct 2026: "look like they're printed on
  // white paper"). Modelled on real point-of-care analyser printouts: grouped sections, the
  // value with a flag, the unit, and [low - high] reference limits, with a legend at the foot.
  // UK units (kPa, mmol/L). The limits are typical adult values; real labs set their own.
  //   ref   [low, high]   outside it: one arrow
  //   crit  [low, high]   outside it: two arrows (null = no limit on that side)
  // A venous sample's pO2 is printed without limits or a flag: venous pO2 is meant to be low.
  // Analytes the gas does not carry are left off rather than invented.
  var GAS_ROWS = [{
    section: 'Blood gas values'
  }, {
    k: 'pH',
    label: 'pH',
    dp: 2,
    unit: '',
    ref: [7.35, 7.45],
    crit: [7.20, 7.60]
  }, {
    k: 'pCO2',
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "pCO", /*#__PURE__*/React.createElement("sub", null, "2")),
    dp: 1,
    unit: 'kPa',
    ref: [4.7, 6.0],
    crit: [2.7, 9.3]
  }, {
    k: 'pO2',
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "pO", /*#__PURE__*/React.createElement("sub", null, "2")),
    dp: 1,
    unit: 'kPa',
    ref: [10.0, 13.3],
    crit: [5.3, null],
    arterialOnly: true
  }, {
    k: 'BE',
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "cBase(Ecf)", /*#__PURE__*/React.createElement("sub", null, "c")),
    dp: 1,
    unit: 'mmol/L',
    ref: [-2.0, 3.0],
    signed: true,
    calc: true
  }, {
    k: 'HCO3',
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "cHCO", /*#__PURE__*/React.createElement("sub", null, "3"), /*#__PURE__*/React.createElement("sup", null, "\u2212"), "(P,st)", /*#__PURE__*/React.createElement("sub", null, "c")),
    dp: 1,
    unit: 'mmol/L',
    ref: [22.0, 26.0],
    calc: true
  }, {
    section: 'Electrolyte values'
  }, {
    k: 'K',
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "cK", /*#__PURE__*/React.createElement("sup", null, "+")),
    dp: 1,
    unit: 'mmol/L',
    ref: [3.5, 5.3],
    crit: [2.5, 6.5]
  }, {
    k: 'Na',
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "cNa", /*#__PURE__*/React.createElement("sup", null, "+")),
    dp: 0,
    unit: 'mmol/L',
    ref: [135, 145],
    crit: [120, 160]
  }, {
    k: 'Ca',
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "cCa", /*#__PURE__*/React.createElement("sup", null, "2+")),
    dp: 2,
    unit: 'mmol/L',
    ref: [1.15, 1.33],
    crit: [0.75, 1.60]
  }, {
    section: 'Metabolite values'
  }, {
    k: 'Glu',
    label: 'cGlu',
    dp: 1,
    unit: 'mmol/L',
    ref: [4.0, 7.8],
    crit: [2.2, 25.0]
  }, {
    k: 'Lac',
    label: 'cLac',
    dp: 1,
    unit: 'mmol/L',
    ref: [0.5, 2.0],
    crit: [null, 4.0]
  }, {
    k: 'Osm',
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "mOsm", /*#__PURE__*/React.createElement("sub", null, "c")),
    dp: 0,
    unit: 'mmol/kg',
    ref: [275, 295],
    calc: true
  }];
  var gasFlag = function gasFlag(row, n, arterial) {
    if (row.arterialOnly && !arterial) return '';
    var c = row.crit || [];
    if (c[0] !== null && c[0] !== undefined && n < c[0]) return '↓↓';
    if (c[1] !== null && c[1] !== undefined && n > c[1]) return '↑↑';
    if (n < row.ref[0]) return '↓';
    if (n > row.ref[1]) return '↑';
    return '';
  };
  var fmtGas = function fmtGas(n, dp, signed) {
    return (signed && n > 0 ? '+' : '') + n.toFixed(dp).replace('-', '−');
  };
  var pad2 = function pad2(n) {
    return String(n).padStart(2, '0');
  };
  var GasPrintout = function GasPrintout(_ref2) {
    var gas = _ref2.gas;
    var g = gas || {};
    var arterial = g.sample === 'Arterial';
    var when = new Date(Number(g.takenAt) || Date.now());
    var stamp = "".concat(pad2(when.getDate()), "/").concat(pad2(when.getMonth() + 1), "/").concat(when.getFullYear(), " ").concat(pad2(when.getHours()), ":").concat(pad2(when.getMinutes()));
    var fio2 = Number(g.fio2);
    var temp = Number(g.temp);
    var box = function box(on) {
      return /*#__PURE__*/React.createElement("span", {
        className: "inline-block w-[1.1em] text-center border border-neutral-800 leading-[1em] mr-1 text-[0.8em]"
      }, on ? '✕' : ' ');
    };
    // Only the rows the gas carries; a section with none of its rows is left out too.
    var rows = [];
    GAS_ROWS.forEach(function (r) {
      if (r.section) {
        rows.push(r);
        return;
      }
      var n = Number(g[r.k]);
      if (g[r.k] === undefined || g[r.k] === null || g[r.k] === '' || !Number.isFinite(n)) return;
      rows.push(Object.assign({
        n: n
      }, r));
    });
    var shown = rows.filter(function (r, i) {
      return !r.section || rows[i + 1] && !rows[i + 1].section;
    });
    var anyCalc = shown.some(function (r) {
      return r.calc;
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-[#fbfbf8] text-neutral-900 rounded-sm shadow-[0_2px_10px_rgba(0,0,0,0.5)] px-3 sm:px-4 pt-3 pb-3 font-sans text-[13px] min-[400px]:text-[14px] sm:text-base leading-snug max-h-[76vh] overflow-y-auto overflow-x-auto",
      "data-testid": "vbg-grid",
      role: "group",
      "aria-label": "".concat(arterial ? 'Arterial' : 'Venous', " blood gas printout")
    }, /*#__PURE__*/React.createElement("div", {
      className: "border-b border-neutral-800 pb-2 mb-1.5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-baseline gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "font-semibold tracking-wide"
    }, "Blood gas report"), /*#__PURE__*/React.createElement("span", {
      className: "text-[0.8em] text-neutral-600 tabular-nums"
    }, stamp)), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-[auto_1fr] gap-x-3 text-[0.85em] mt-1"
    }, /*#__PURE__*/React.createElement("span", null, "Patient ID"), /*#__PURE__*/React.createElement("span", {
      className: "font-mono"
    }, g.patientId || 'SIM-0001'), /*#__PURE__*/React.createElement("span", null, "Sample type"), /*#__PURE__*/React.createElement("span", {
      "data-testid": "gas-sample",
      className: "flex flex-wrap gap-x-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "whitespace-nowrap"
    }, box(!arterial), "Venous"), /*#__PURE__*/React.createElement("span", {
      className: "whitespace-nowrap"
    }, box(arterial), "Arterial"), /*#__PURE__*/React.createElement("span", {
      className: "whitespace-nowrap"
    }, box(false), "Capillary")), /*#__PURE__*/React.createElement("span", null, "T"), /*#__PURE__*/React.createElement("span", {
      className: "tabular-nums"
    }, Number.isFinite(temp) && temp > 0 ? temp.toFixed(1) : '37.0', " \xB0C"), /*#__PURE__*/React.createElement("span", null, "FO", /*#__PURE__*/React.createElement("sub", null, "2"), "(I)"), /*#__PURE__*/React.createElement("span", {
      className: "tabular-nums",
      "data-testid": "gas-fio2"
    }, Number.isFinite(fio2) && fio2 > 0 ? fio2.toFixed(2) : '–'))), /*#__PURE__*/React.createElement("table", {
      className: "w-full border-collapse tabular-nums"
    }, /*#__PURE__*/React.createElement("tbody", null, shown.map(function (r, i) {
      if (r.section) return /*#__PURE__*/React.createElement("tr", {
        key: 's' + i
      }, /*#__PURE__*/React.createElement("td", {
        colSpan: 4,
        className: "font-semibold text-[0.95em] pb-0.5 ".concat(i ? 'pt-2' : '')
      }, r.section));
      var flag = gasFlag(r, r.n, arterial);
      var noRange = r.arterialOnly && !arterial;
      return /*#__PURE__*/React.createElement("tr", {
        key: r.k,
        "data-testid": "gas-row-".concat(r.k)
      }, /*#__PURE__*/React.createElement("td", {
        className: "pl-1 sm:pl-3 pr-2 whitespace-nowrap"
      }, r.label), /*#__PURE__*/React.createElement("td", {
        className: "text-right whitespace-nowrap font-semibold",
        "data-testid": "gas-val-".concat(r.k)
      }, /*#__PURE__*/React.createElement("span", {
        className: "inline-block min-w-[1.7em] text-left font-normal",
        title: flag ? flag.length > 1 ? 'Outside critical range' : 'Outside reference range' : undefined
      }, flag), fmtGas(r.n, r.dp, r.signed)), /*#__PURE__*/React.createElement("td", {
        className: "pl-1 sm:pl-2 pr-1 whitespace-nowrap text-[0.85em]"
      }, r.unit), /*#__PURE__*/React.createElement("td", {
        className: "pl-1 text-right max-sm:whitespace-normal whitespace-nowrap text-[0.85em] text-neutral-700"
      }, noRange ? '' : "[\xA0".concat(fmtGas(r.ref[0], r.dp, r.signed), "\xA0\u2013 ").concat(fmtGas(r.ref[1], r.dp, r.signed), "\xA0]")));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "border-t border-neutral-800 mt-3 pt-1.5 text-[0.75em] grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 text-neutral-800"
    }, /*#__PURE__*/React.createElement("span", null, '↑ ↓'), /*#__PURE__*/React.createElement("span", null, "Outside reference range"), /*#__PURE__*/React.createElement("span", null, '↑↑ ↓↓'), /*#__PURE__*/React.createElement("span", null, "Outside critical range"), anyCalc && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "italic"
    }, "c"), /*#__PURE__*/React.createElement("span", null, "Calculated value"))));
  };

  // The 12-lead renderer lives in data/rhythms.js (RHYTHMS.render12Lead) so this monitor and the
  // standalone defibrillator page draw the identical recording from the identical registry.
  var render12Lead = function render12Lead(canvas, rhythm, scenario, hr) {
    return window.RHYTHMS.render12Lead(canvas, rhythm, scenario, hr);
  };

  // An ECG result with no real image: the 12-lead drawn from the rhythm and rate when it was taken.
  var Live12Lead = function Live12Lead(_ref3) {
    var rhythm = _ref3.rhythm,
      hr = _ref3.hr,
      scenario = _ref3.scenario,
      className = _ref3.className,
      testId = _ref3.testId;
    var ref = useRef(null);
    useEffect(function () {
      if (ref.current) render12Lead(ref.current, rhythm, scenario, hr);
    }, [rhythm, hr]);
    return /*#__PURE__*/React.createElement("canvas", {
      ref: ref,
      width: "1000",
      height: "640",
      className: className,
      "data-testid": testId,
      "data-hr": Number.isFinite(Number(hr)) ? Math.round(Number(hr)) : undefined,
      "aria-label": "12-lead ECG",
      role: "img"
    });
  };

  // =========================================================================================
  // THE URINE DIPSTICK (29 Oct 2026). Drawn from the result (generateUrine): one pad per test,
  // coloured from negative to strongly positive, with the reading printed beside it, and a
  // pregnancy test cassette when the result has one. The colours are illustrative (each make of
  // strip has its own chart); the printed reading is the result.
  // =========================================================================================
  var DIP_PADS = [{
    k: 'leuks',
    label: 'Leucocytes',
    scale: ['#efe6cf', '#e3d3d6', '#cdb1cf', '#a97fbf', '#7b4c9e']
  }, {
    k: 'nitrites',
    label: 'Nitrite',
    scale: ['#f7f1e3', '#f0a3bf']
  }, {
    k: 'protein',
    label: 'Protein',
    scale: ['#e3df6e', '#cfd776', '#aecb7c', '#86b984', '#5aa38b', '#3c8a86']
  }, {
    k: 'blood',
    label: 'Blood',
    scale: ['#f2d36b', '#d9c95d', '#b3c05a', '#7ea24f', '#3f7a45', '#2a5e3a']
  }, {
    k: 'ketones',
    label: 'Ketones',
    scale: ['#f2dcbc', '#e8bfa9', '#d99191', '#bd5f72', '#934057', '#6c2a45']
  }, {
    k: 'glucose',
    label: 'Glucose',
    scale: ['#86c9c7', '#97c79a', '#acb863', '#a58c3d', '#8b6230', '#6a4024']
  }];
  // '-' or 'Negative' 0, 'Trace' 0.5, '+' to '++++' 1 to 4 (any other positive reading 1).
  var dipGrade = function dipGrade(v) {
    var t = String(v === undefined || v === null ? '' : v).trim();
    if (!t || t === '-' || /^neg/i.test(t)) return 0;
    if (/^trace/i.test(t)) return 0.5;
    var plus = t.match(/\+/g);
    return plus ? plus.length : /pos/i.test(t) ? 1 : 0;
  };
  var UrineDipstick = function UrineDipstick(_ref4) {
    var urine = _ref4.urine;
    var u = urine || {};
    var pads = DIP_PADS.filter(function (p) {
      return u[p.k] !== undefined;
    });
    var hcg = u.bhcg !== undefined ? /pos/i.test(String(u.bhcg)) : null;
    var reading = function reading(v) {
      return dipGrade(v) === 0 ? 'Negative' : String(v);
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-white text-neutral-900 rounded shadow-inner p-3 font-mono text-[15px] md:text-base",
      "data-testid": "urine-dipstick"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold border-b border-neutral-800 pb-1 mb-2"
    }, "URINE DIPSTICK"), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-3 items-stretch"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-none w-9 bg-neutral-100 border border-neutral-300 rounded-sm flex flex-col items-center gap-1.5 py-2",
      "aria-hidden": "true"
    }, pads.map(function (p) {
      var g = dipGrade(u[p.k]);
      var i = p.scale.length === 2 ? g > 0 ? 1 : 0 : g === 0 ? 0 : g === 0.5 ? 1 : Math.min(p.scale.length - 1, Math.round(g) + 1);
      return /*#__PURE__*/React.createElement("span", {
        key: p.k,
        className: "block w-6 h-6 rounded-[2px] border border-black/10",
        style: {
          background: p.scale[i]
        }
      });
    })), /*#__PURE__*/React.createElement("table", {
      className: "flex-1 border-collapse self-start"
    }, /*#__PURE__*/React.createElement("tbody", null, pads.map(function (p) {
      return /*#__PURE__*/React.createElement("tr", {
        key: p.k,
        className: "h-[30px]",
        "data-testid": "dip-".concat(p.k)
      }, /*#__PURE__*/React.createElement("td", {
        className: "pr-3"
      }, p.label), /*#__PURE__*/React.createElement("td", {
        className: "text-right ".concat(dipGrade(u[p.k]) > 0 ? 'font-bold' : '')
      }, reading(u[p.k])));
    })))), hcg !== null && /*#__PURE__*/React.createElement("div", {
      className: "mt-3 pt-2 border-t border-neutral-300 flex items-center gap-3",
      "data-testid": "urine-hcg"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-none w-24 h-10 bg-neutral-100 border border-neutral-300 rounded-full flex items-center justify-center",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-12 h-5 bg-white border border-neutral-300 rounded-sm relative"
    }, /*#__PURE__*/React.createElement("span", {
      className: "absolute top-0 bottom-0 left-3 w-[3px] bg-rose-700"
    }), hcg && /*#__PURE__*/React.createElement("span", {
      className: "absolute top-0 bottom-0 left-7 w-[3px] bg-rose-700"
    }))), /*#__PURE__*/React.createElement("div", null, "Pregnancy test (hCG): ", /*#__PURE__*/React.createElement("b", null, hcg ? 'POSITIVE' : 'Negative'))), /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-neutral-500 mt-2 font-sans"
    }, "Pad colours are illustrative; the printed reading is the result."));
  };

  // =========================================================================================
  // THE DEFIBRILLATOR, HOSTED ON THE STUDENT MONITOR.
  //
  // WHY THIS EXISTS. defib/index.html has ZERO Firebase: it is BroadcastChannel-only, which only
  // works between tabs of the SAME browser on the SAME device. Opened on a second physical
  // device (the usual setup — controller on the facilitator's laptop, defib on a tablet by the
  // bed) it silently showed a healthy sinus patient at HR 75 and answered "NO SHOCK ADVISED" in
  // VF. This component is driven by the SAME Firebase session sync as the rest of the monitor,
  // so it is correct on any device.
  //
  // THE OBS STAY VISIBLE. This extends the existing arrest-view dual-trace pattern
  // (LEAD II + PADS) rather than inventing a new layout, and puts the live vitals column
  // alongside. It is a flex row on landscape tablets and stacks with its own scroll container
  // at narrow widths (no fixed min-widths, no horizontal overflow — the app has had a
  // mobile-overflow bug class before and this must not reintroduce it).
  //
  // Every student press is pushed to sessions/<CODE>/deviceEvents (PUSH semantics, its own
  // node) NOT to sessions/<CODE>/command, which is a single set() slot already owned by NIBP.
  // The controller converges them all on applyShockOutcome / deliverShock.
  // =========================================================================================
  // =========================================================================================
  // THE DEFIB AND THE VENTILATOR ON A PATIENT SCREEN. Each is the same device page a tablet
  // uses (defib/index.html, vent/index.html), embedded, so there is one of each to maintain and
  // the screen gets every feature the tablet has.
  //
  // A device that is in the room stays LOADED while the screen switches away from it: it is only
  // hidden, so the ventilator keeps ventilating and alarming, the defib keeps its charge, and
  // switching back is instant. The facilitator brings a device in (Defib / Ventilator on the
  // controller); a screen that can show it brings it to the front, and the candidate switches
  // with the buttons at the bottom left. Which screen shows what is set per screen
  // (window.SimScreens: all-in-one, monitor only, or defib and ventilator).
  // =========================================================================================
  var DEVICE_PAGES = {
    defib: {
      title: 'Defibrillator',
      src: 'defib/index.html',
      testId: 'monitor-defib'
    },
    vent: {
      title: 'Ventilator',
      src: 'vent/index.html',
      testId: 'monitor-vent'
    }
  };
  var DeviceLayer = function DeviceLayer(_ref5) {
    var kind = _ref5.kind,
      sessionID = _ref5.sessionID,
      shown = _ref5.shown;
    var d = DEVICE_PAGES[kind];
    return /*#__PURE__*/React.createElement("div", {
      className: "absolute inset-0 z-[110] bg-black flex flex-col ".concat(shown ? 'animate-fadeIn' : 'invisible pointer-events-none'),
      "data-testid": d.testId,
      "aria-hidden": !shown
    }, /*#__PURE__*/React.createElement("iframe", {
      title: d.title,
      src: "".concat(d.src, "?session=").concat(encodeURIComponent(sessionID || ''), "&embedded=1"),
      className: "w-full h-full border-0 bg-black",
      allow: "screen-wake-lock; autoplay; fullscreen"
    }));
  };
  var SWITCH_LABELS = {
    monitor: 'Monitor',
    defib: 'Defib',
    vent: 'Ventilator'
  };
  var SWITCH_ICONS = {
    monitor: 'activity',
    defib: 'zap',
    vent: 'wind'
  };
  // Bottom left over the ventilator; TOP left over the defib, whose page leaves a margin there for
  // it (bottom left it covered SYNC). Over the monitor it is `inline`: the first cell of the
  // investigations bar, which makes room for it. Floating over the monitor it covered the 12-Lead
  // button.
  var ScreenSwitcher = function ScreenSwitcher(_ref6) {
    var options = _ref6.options,
      value = _ref6.value,
      onChange = _ref6.onChange,
      extra = _ref6.extra,
      inline = _ref6.inline;
    var _window2 = window,
      Lucide = _window2.Lucide;
    return /*#__PURE__*/React.createElement("div", {
      role: "group",
      "aria-label": "Show on this screen",
      "data-testid": "screen-switcher",
      className: inline ? 'flex-none flex items-center gap-1 px-1 bg-slate-900 border-r border-slate-800' : "absolute left-2 ".concat(value === 'defib' ? 'top-0.5' : 'bottom-2', " z-[120] flex gap-1 p-1 rounded-xl bg-slate-900/90 border border-slate-600 shadow-lg")
    }, options.map(function (k) {
      return /*#__PURE__*/React.createElement("button", {
        key: k,
        type: "button",
        onClick: function onClick() {
          return onChange(k);
        },
        "aria-pressed": value === k,
        "data-screen": k,
        "aria-label": SWITCH_LABELS[k],
        className: "min-h-[40px] px-3 rounded-lg flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider ".concat(value === k ? 'bg-sky-600 text-white' : 'text-slate-200 hover:bg-slate-700')
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: SWITCH_ICONS[k],
        className: "w-4 h-4"
      }), " ", /*#__PURE__*/React.createElement("span", {
        className: inline ? 'hidden sm:inline' : undefined
      }, SWITCH_LABELS[k]));
    }), extra);
  };
  // Which view is in front. A device the facilitator brings in comes to the front; one taken
  // away hands the screen back. `avail` lists what this screen can show right now, in order.
  // `request` is the facilitator's "Patient screens show" switch on the controller ({ view, at },
  // carried in the live defib object): each new request puts that view in front, if this screen
  // has it. A request this screen cannot show yet is dropped after a few seconds, so a screen
  // given the device much later does not jump to it out of the blue.
  var REQUEST_WAIT_MS = 15000;
  var useFrontView = function useFrontView(avail, opened, fallback, request) {
    var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      front = _useState2[0],
      setFront = _useState2[1];
    var prev = useRef({});
    var asked = useRef({
      at: null,
      seen: 0,
      done: false
    });
    useEffect(function () {
      var p = prev.current;
      var newly = ['defib', 'vent'].find(function (k) {
        return opened[k] && !p[k] && avail.includes(k);
      });
      if (newly) setFront(newly);
      prev.current = _objectSpread({}, opened);
    }, [opened.defib, opened.vent, avail.join(',')]);
    var reqAt = request && request.at ? request.at : null;
    var reqView = request && request.view ? request.view : null;
    useEffect(function () {
      if (!reqAt || !reqView) return;
      var a = asked.current;
      if (a.at !== reqAt) asked.current = {
        at: reqAt,
        seen: Date.now(),
        done: false
      };
      var cur = asked.current;
      if (cur.done) return;
      if (Date.now() - cur.seen > REQUEST_WAIT_MS) {
        cur.done = true;
        return;
      }
      if (avail.includes(reqView)) {
        setFront(reqView);
        cur.done = true;
      }
    }, [reqAt, reqView, avail.join(',')]);
    var shown = avail.includes(front) ? front : fallback;
    return [shown, setFront];
  };
  // Keep a patient screen awake (the monitor has its own, fuller version).
  var useWakeLock = function useWakeLock() {
    useEffect(function () {
      if (!('wakeLock' in navigator)) return;
      var lock = null,
        gone = false;
      var req = /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                if (!(gone || document.visibilityState !== 'visible' || lock && !lock.released)) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                _context.p = 1;
                _context.n = 2;
                return navigator.wakeLock.request('screen');
              case 2:
                lock = _context.v;
                _context.n = 4;
                break;
              case 3:
                _context.p = 3;
                _t = _context.v;
              case 4:
                return _context.a(2);
            }
          }, _callee, null, [[1, 3]]);
        }));
        return function req() {
          return _ref7.apply(this, arguments);
        };
      }();
      req();
      var onVis = function onVis() {
        return req();
      };
      document.addEventListener('visibilitychange', onVis);
      document.addEventListener('pointerdown', onVis);
      return function () {
        gone = true;
        document.removeEventListener('visibilitychange', onVis);
        document.removeEventListener('pointerdown', onVis);
        try {
          if (lock) lock.release();
        } catch (e) {}
      };
    }, []);
  };
  var toggleFullscreenDoc = function toggleFullscreenDoc() {
    try {
      if (document.fullscreenElement || document.webkitFullscreenElement) (document.exitFullscreen || document.webkitExitFullscreen).call(document);else {
        var el = document.documentElement;
        var p = (el.requestFullscreen || el.webkitRequestFullscreen).call(el);
        if (p && p["catch"]) p["catch"](function () {});
      }
    } catch (e) {}
  };

  // A screen without the monitor: its device(s), ready all the time, with the one the facilitator
  // last brought in at the front when it has both.
  // The two ways off the "Simulation complete" card on a patient screen: back to the app's first
  // screen (this device stops being a patient screen), or restart this screen as a blank patient
  // screen on the same code, waiting for the controller's next scenario.
  var FinishedActions = function FinishedActions(_ref8) {
    var onRestart = _ref8.onRestart;
    var _window3 = window,
      Lucide = _window3.Lucide;
    var backToStart = function backToStart() {
      try {
        sessionStorage.removeItem('wmebem_device_role');
      } catch (e) {}
      window.location.href = window.location.pathname;
    };
    var btn = 'min-h-[48px] px-5 rounded-lg font-bold flex items-center justify-center gap-2';
    return /*#__PURE__*/React.createElement("div", {
      className: "mt-6 flex flex-col sm:flex-row gap-3 justify-center",
      "data-testid": "finished-actions"
    }, onRestart && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: onRestart,
      "data-testid": "finished-restart",
      className: "".concat(btn, " bg-sky-600 hover:bg-sky-500 text-white")
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "monitor",
      className: "w-5 h-5"
    }), " Restart monitor"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: backToStart,
      "data-testid": "finished-home",
      className: "".concat(btn, " bg-slate-700 hover:bg-slate-600 text-white")
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "arrow-left",
      className: "w-5 h-5"
    }), " Back to start screen"));
  };
  var DeviceScreen = function DeviceScreen(_ref9) {
    var sim = _ref9.sim,
      sessionID = _ref9.sessionID,
      parts = _ref9.parts,
      onShows = _ref9.onShows,
      onHost = _ref9.onHost,
      onRestart = _ref9.onRestart;
    var _window4 = window,
      Lucide = _window4.Lucide;
    var state = sim.state;
    useWakeLock();
    var devices = ['defib', 'vent'].filter(function (k) {
      return (parts || ['defib', 'vent']).includes(k);
    });
    var opened = {
      defib: devices.includes('defib') && !!state.defibPanelOpen,
      vent: devices.includes('vent') && !!state.ventPanelOpen
    };
    var fallback = devices.length > 1 ? opened.vent && !opened.defib ? 'vent' : 'defib' : devices[0];
    var _useFrontView = useFrontView(devices, opened, fallback, state.defib && state.defib.screenFront),
      _useFrontView2 = _slicedToArray(_useFrontView, 2),
      shown = _useFrontView2[0],
      setFront = _useFrontView2[1];
    useEffect(function () {
      if (onShows) onShows(shown);
    }, [shown]);
    var hosted = state.isFinished ? [] : devices;
    useEffect(function () {
      if (onHost) onHost(hosted);
    }, [hosted.join(',')]);
    if (state.isFinished) {
      return /*#__PURE__*/React.createElement("div", {
        className: "h-full w-full bg-black text-white flex items-center justify-center p-6",
        role: "status",
        "aria-live": "polite"
      }, /*#__PURE__*/React.createElement("div", {
        className: "max-w-xl w-full bg-slate-900 border border-slate-700 rounded-lg p-8 text-center"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "check-circle",
        className: "w-14 h-14 text-emerald-500 mx-auto mb-4"
      }), /*#__PURE__*/React.createElement("h1", {
        className: "text-3xl font-bold mb-2"
      }, "Simulation complete"), /*#__PURE__*/React.createElement("p", {
        className: "text-slate-300"
      }, "Please turn to your facilitator for the debrief."), /*#__PURE__*/React.createElement(FinishedActions, {
        onRestart: onRestart
      })));
    }
    var fsSupported = !!(document.documentElement.requestFullscreen || document.documentElement.webkitRequestFullscreen);
    var fsButton = fsSupported && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: toggleFullscreenDoc,
      "aria-label": "Full screen",
      title: "Full screen",
      className: "min-h-[40px] px-2 rounded-lg text-slate-300 hover:bg-slate-700"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "maximize",
      className: "w-4 h-4"
    }));
    return /*#__PURE__*/React.createElement("div", {
      className: "h-full w-full relative bg-black overflow-hidden",
      "data-testid": "device-screen"
    }, devices.length > 1 ? /*#__PURE__*/React.createElement(ScreenSwitcher, {
      options: devices,
      value: shown,
      onChange: setFront,
      extra: fsButton
    }) : fsButton && /*#__PURE__*/React.createElement("div", {
      className: "absolute left-2 ".concat(shown === 'defib' ? 'top-0.5' : 'bottom-2', " z-[120] p-1 rounded-xl bg-slate-900/80 border border-slate-600")
    }, fsButton));
  };
  var MonitorScreen = function MonitorScreen(_ref0) {
    var _state$vitals2, _scenario$patientAge, _scenario$wetflag, _state$monitorTimer;
    var sim = _ref0.sim,
      sessionID = _ref0.sessionID,
      parts = _ref0.parts,
      onShows = _ref0.onShows,
      onHost = _ref0.onHost,
      onRestart = _ref0.onRestart;
    var _window5 = window,
      VitalDisplay = _window5.VitalDisplay,
      ECGMonitor = _window5.ECGMonitor,
      Lucide = _window5.Lucide,
      Button = _window5.Button,
      Modal = _window5.Modal;
    var state = sim.state,
      enableAudio = sim.enableAudio,
      triggerNIBP = sim.triggerNIBP,
      toggleNIBPMode = sim.toggleNIBPMode,
      revealInvestigation = sim.revealInvestigation;
    var vitals = state.vitals,
      prevVitals = state.prevVitals,
      rhythm = state.rhythm,
      flash = state.flash,
      activeInterventions = state.activeInterventions,
      etco2Enabled = state.etco2Enabled,
      etco2Pathology = state.etco2Pathology,
      cprInProgress = state.cprInProgress,
      scenario = state.scenario,
      nibp = state.nibp,
      monitorPopup = state.monitorPopup,
      notification = state.notification,
      arrestPanelOpen = state.arrestPanelOpen,
      defibPanelOpen = state.defibPanelOpen,
      loadingInvestigations = state.loadingInvestigations,
      showWetflag = state.showWetflag;
    // This screen also shows the defib and/or the ventilator, when the facilitator brings them
    // in, if the controller has given it them (window.SimScreens); otherwise they are elsewhere.
    var partList = parts || ['monitor', 'defib', 'vent'];
    var defibHere = partList.includes('defib') && !!defibPanelOpen;
    var ventHere = partList.includes('vent') && !!state.ventPanelOpen;
    var _useFrontView3 = useFrontView(['monitor'].concat(defibHere ? ['defib'] : [], ventHere ? ['vent'] : []), {
        defib: defibHere,
        vent: ventHere
      }, 'monitor', state.defib && state.defib.screenFront),
      _useFrontView4 = _slicedToArray(_useFrontView3, 2),
      shownView = _useFrontView4[0],
      setFrontView = _useFrontView4[1];
    useEffect(function () {
      if (onShows) onShows(shownView);
    }, [shownView]);
    var hosted = [].concat(defibHere ? ['defib'] : [], ventHere ? ['vent'] : []);
    useEffect(function () {
      if (onHost) onHost(hosted);
    }, [hosted.join(',')]);
    var switchOptions = ['monitor'].concat(hosted);
    // Over the obs the switcher sits in the investigations bar, so it never hides a button. Over
    // a device, or under the manual-defibrillator overlay (which covers that bar), it floats.
    var switcherInline = shownView === 'monitor' && !(arrestPanelOpen && !defibHere);
    var syncStatus = state.syncStatus || {
      state: 'connecting',
      message: 'Connecting to live session…'
    };
    var syncProblem = ['unavailable', 'disconnected', 'error', 'degraded'].includes(syncStatus.state);
    // Each sensor gates exactly its own value/trace. Derived from the shared
    // engine helper (window.getSensors) off activeInterventions, which is already on the wire, so
    // the student monitor needs no new sync key and can never disagree with the controller.
    // 'Obs' (Attach Monitoring) still implies every continuous sensor, so all 254 premade
    // scenarios and resumed sessions behave exactly as before. Quick Sim starts with nothing
    // attached, like every other mode.
    var sensors = window.getSensors ? window.getSensors(state) : null;
    var hasMonitoring = sensors ? sensors.any : activeInterventions.has('Obs');
    var sEcg = sensors ? sensors.ecg : hasMonitoring;
    var sSpo2 = sensors ? sensors.spo2 : hasMonitoring;
    var sNibp = sensors ? sensors.nibp : hasMonitoring;
    var sTemp = sensors ? sensors.temp : hasMonitoring;
    var hasArtLine = activeInterventions.has('ArtLine');
    // Point-of-care readings: revealed AT THE MOMENT THEY WERE TAKEN, with a timestamp, rather
    // than tracking live (the clinically important distinction, and what NIBP already does).
    var poc = state.pocReadings || {};
    var capnoVentilating = window.isCapnoVentilating ? window.isCapnoVentilating(state, vitals) : true;
    // The shark-fin severity arrives as a plain top-level number on the wire
    // (`co2Severity`), computed once from the authoritative controller state, so the student
    // monitor and the facilitator strip draw the identical capnogram shape and can never disagree.
    var co2Severity = Number.isFinite(state.co2Severity) ? state.co2Severity : 0;

    // Starts hidden when this page's sound is already on: the engine (and its AudioContext) outlives
    // this screen, which remounts for every new scenario, so a monitor someone already tapped (or a
    // browser that allows sound for the site) used to ask again at the start of every scenario.
    var _useState3 = useState(function () {
        return sim.audioContextState === 'running';
      }),
      _useState4 = _slicedToArray(_useState3, 2),
      audioEnabled = _useState4[0],
      setAudioEnabled = _useState4[1];

    // ---- KEEP THE ROOM MONITOR AWAKE ------------------------------------------------------
    // A tablet on the wall used to dim and lock mid-scenario, because nothing asked it not to.
    // The Screen Wake Lock API holds the screen on while this page is visible. The browser
    // drops the lock whenever the tab is hidden, so it is re-requested on every return to
    // visible, and again inside the "Tap to Enable Sound" gesture (some browsers want one).
    // Unsupported browsers (older iOS) simply carry on as before; the chip below says so.
    var wakeLockRef = useRef(null);
    var _useState5 = useState('wakeLock' in navigator ? 'pending' : 'unsupported'),
      _useState6 = _slicedToArray(_useState5, 2),
      wakeState = _useState6[0],
      setWakeState = _useState6[1];
    var requestWakeLock = /*#__PURE__*/function () {
      var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var lock, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(!('wakeLock' in navigator) || document.visibilityState !== 'visible')) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (!(wakeLockRef.current && !wakeLockRef.current.released)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              _context2.p = 2;
              _context2.n = 3;
              return navigator.wakeLock.request('screen');
            case 3:
              lock = _context2.v;
              wakeLockRef.current = lock;
              setWakeState('on');
              lock.addEventListener('release', function () {
                if (wakeLockRef.current === lock) setWakeState('released');
              });
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              setWakeState('denied');
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[2, 4]]);
      }));
      return function requestWakeLock() {
        return _ref1.apply(this, arguments);
      };
    }();
    useEffect(function () {
      requestWakeLock();
      var onVis = function onVis() {
        if (document.visibilityState === 'visible') requestWakeLock();
      };
      document.addEventListener('visibilitychange', onVis);
      return function () {
        document.removeEventListener('visibilitychange', onVis);
        try {
          if (wakeLockRef.current) wakeLockRef.current.release();
        } catch (e) {}
        wakeLockRef.current = null;
      };
    }, []);
    // Full screen: hides the browser chrome on the room screen. Prefixed for older Safari.
    var _useState7 = useState(!!(document.fullscreenElement || document.webkitFullscreenElement)),
      _useState8 = _slicedToArray(_useState7, 2),
      isFullscreen = _useState8[0],
      setIsFullscreen = _useState8[1];
    useEffect(function () {
      var onFs = function onFs() {
        return setIsFullscreen(!!(document.fullscreenElement || document.webkitFullscreenElement));
      };
      document.addEventListener('fullscreenchange', onFs);
      document.addEventListener('webkitfullscreenchange', onFs);
      return function () {
        document.removeEventListener('fullscreenchange', onFs);
        document.removeEventListener('webkitfullscreenchange', onFs);
      };
    }, []);
    var fsSupported = !!(document.documentElement.requestFullscreen || document.documentElement.webkitRequestFullscreen);
    var toggleFullscreen = function toggleFullscreen() {
      try {
        if (document.fullscreenElement || document.webkitFullscreenElement) {
          (document.exitFullscreen || document.webkitExitFullscreen).call(document);
        } else {
          var el = document.documentElement;
          var p = (el.requestFullscreen || el.webkitRequestFullscreen).call(el);
          if (p && p["catch"]) p["catch"](function () {});
        }
      } catch (e) {/* not allowed here: nothing to do */}
      requestWakeLock();
    };
    // The overlay must be able to come BACK: iOS and tab-backgrounding re-suspend the
    // AudioContext, and a one-way flag left the monitor permanently silent with no way to fix it.
    var audioContextState = sim.audioContextState;
    useEffect(function () {
      // Any state but running means no sound: 'suspended', or Safari's 'interrupted' (iPad screen
      // lock, a call, Siri). Checking only 'suspended' hid the button on iPads that were still silent.
      var blocked = audioContextState === 'suspended' || audioContextState === 'interrupted';
      if (audioEnabled && blocked) setAudioEnabled(false);
      // Sound came on without the button (a tap anywhere, a press on a device, or the browser
      // allowing it): the button has nothing left to do.
      else if (!audioEnabled && audioContextState === 'running') setAudioEnabled(true);
    }, [audioContextState, audioEnabled]);
    var _useState9 = useState(null),
      _useState0 = _slicedToArray(_useState9, 2),
      invToast = _useState0[0],
      setInvToast = _useState0[1];
    var _useState1 = useState(false),
      _useState10 = _slicedToArray(_useState1, 2),
      show12Lead = _useState10[0],
      setShow12Lead = _useState10[1];
    var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      viewImage = _useState12[0],
      setViewImage = _useState12[1]; // full-screen view of a result image
    var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      viewEcg = _useState14[0],
      setViewEcg = _useState14[1]; // full-screen view of a drawn 12-lead result
    var INV = window.INVESTIGATIONS;
    // A restricted course image (e.g. an ETC X-ray) the facilitator chose to show. It is not in the
    // app: the controller copies the one being shown to the session, and it is registered here
    // so the result card can show it like any other image, with its credit.
    var _useState15 = useState(0),
      _useState16 = _slicedToArray(_useState15, 2),
      courseImageTick = _useState16[0],
      setCourseImageTick = _useState16[1];
    var pendingImage = useRef(null); // a result's image that was not registered yet when it came in
    useEffect(function () {
      if (!sessionID || !window.db || !INV || !INV.registerImage) return;
      var ref = window.db.ref("sessions/".concat(sessionID, "/courseImage"));
      var onValue = function onValue(snap) {
        var v = snap && snap.val();
        if (v && typeof v.key === 'string') {
          INV.registerImage(v.key, v);
          setCourseImageTick(function (t) {
            return t + 1;
          });
        }
      };
      ref.on('value', onValue, function () {});
      return function () {
        return ref.off('value', onValue);
      };
    }, [sessionID]);
    // The scenario's own real 12-lead, if it has one and it still fits the patient's rhythm. The
    // synced scenario carries its results at the top level (scenario.ecg); a locally loaded one
    // under scenario.investigations.
    var scenarioEcgImage = function () {
      var ecg = scenario && (scenario.ecg && scenario.ecg.image ? scenario.ecg : scenario.investigations && scenario.investigations.ecg);
      var key = ecg && ecg.image;
      return INV && key && INV.ecgImageFits(key, state.rhythm) ? key : null;
    }();
    // Fetch the scenario's own images when it loads, so they show at once when a result is sent
    // (the service worker stores each one; they are not stored in advance with the rest of the site).
    var scenarioImageKeys = function () {
      if (!INV || !scenario) return '';
      var keys = [scenario.chestXray, scenario.ct, scenario.pocus, scenario.ecg].concat(_toConsumableArray(Object.values(scenario.investigations || {}))).map(function (r) {
        return r && _typeof(r) === 'object' ? r.image : null;
      }).filter(function (k) {
        return k && INV.IMAGES[k];
      });
      return _toConsumableArray(new Set(keys)).join(' ');
    }();
    useEffect(function () {
      scenarioImageKeys.split(' ').filter(Boolean).forEach(function (k) {
        var im = new Image();
        im.src = INV.IMAGES[k].loop || INV.IMAGES[k].src;
      });
    }, [scenarioImageKeys]);
    var canvasRef = useRef(null);

    // Result cards are told apart by the exact stamp they carry, not by "newer than the last":
    // a team press here stamps the tablet's clock and the controller stamps the laptop's, and
    // comparing the two used to drop the controller's result or clear when the tablet ran fast.
    var seenPopups = useRef(new Set());
    var popupSeen = function popupSeen(ts) {
      return seenPopups.current.has(ts);
    };
    var markPopup = function markPopup(ts) {
      seenPopups.current.add(ts);
      if (seenPopups.current.size > 500) seenPopups.current = new Set(Array.from(seenPopups.current).slice(-250));
    };
    var simChannel = useRef(null);
    useEffect(function () {
      if (show12Lead && canvasRef.current) {
        var _state$vitals;
        render12Lead(canvasRef.current, state.rhythm, state.scenario, (_state$vitals = state.vitals) === null || _state$vitals === void 0 ? void 0 : _state$vitals.hr);
      }
    }, [show12Lead, state.rhythm, (_state$vitals2 = state.vitals) === null || _state$vitals2 === void 0 ? void 0 : _state$vitals2.hr]);
    useEffect(function () {
      // The 12-lead bridge is a local nicety; everything clinical arrives over Firebase. Older iOS
      // Safari has no BroadcastChannel and throwing here would blank the student monitor entirely.
      if (simChannel.current === null) {
        try {
          simChannel.current = 'BroadcastChannel' in window ? new BroadcastChannel('sim_channel') : null;
        } catch (e) {
          console.warn('BroadcastChannel unavailable on monitor', e);
          simChannel.current = null;
        }
      }
      if (!simChannel.current) return;
      simChannel.current.onmessage = function (event) {
        if (event.data.type === 'SHOW_12LEAD') {
          setShow12Lead(true);
        }
      };
      return function () {
        if (simChannel.current) {
          simChannel.current.close();
          simChannel.current = null;
        }
      };
    }, []);
    useEffect(function () {
      // A clear from the controller. Only a clear newer than the result on screen: the controller's
      // live updates carry its last popup, which must not wipe a result the team opened here since.
      // (The database drops null fields, so a synced clear arrives with no type at all.)
      if (monitorPopup && !monitorPopup.type) {
        if (!monitorPopup.timestamp || popupSeen(monitorPopup.timestamp)) return;
        markPopup(monitorPopup.timestamp);
        if (invToast) setInvToast(null);
        if (show12Lead) setShow12Lead(false);
        setViewImage(null);
        return;
      }
      if (monitorPopup && monitorPopup.type && monitorPopup.timestamp && !popupSeen(monitorPopup.timestamp)) {
        markPopup(monitorPopup.timestamp);
        var type = monitorPopup.type;
        // The patient picture is drawn over the whole screen by MonitorContainer, not as a result card.
        if (type === 'Patient picture') {
          setInvToast(null);
          setViewImage(null);
          return;
        }
        var title = type;
        var content = "No findings recorded.";
        var ct = monitorPopup.customText;
        // The VBG as the analyser prints it: white paper, sections, flags and reference limits.
        // (Values stay at least 16 px on a room screen so they read from across the room.)
        var vbgGrid = function vbgGrid(v) {
          return /*#__PURE__*/React.createElement(GasPrintout, {
            gas: v
          });
        };
        // The result as data/investigations.js resolveResult gives it: the scenario's own result
        // with its picture, or a picture made for it (a normal film for the patient's age, the
        // scan's windows, a 12-lead drawn from the live rhythm, the urine dipstick).
        var res = null;
        if (ct && _typeof(ct) === 'object' && ct.__vbg) {
          // Structured VBG payload from revealInvestigation('VBG')
          content = vbgGrid(ct);
        } else if (ct) {
          content = ct;
        } else if (type === 'VBG' && scenario && scenario.vbg) {
          content = vbgGrid(Object.assign({
            sample: 'Venous'
          }, scenario.vbg));
        } else if (scenario && INV && INV.resolveResult && INV.FIELD[type]) {
          res = INV.resolveResult(scenario, type, {
            rhythm: state.rhythm,
            age: scenario.patientAge
          }, {
            normal: !!monitorPopup.normal
          });
          content = res.text || (res.live12 || res.urine ? '' : content);
        }
        // The image: one the facilitator chose with the result, or the resolved one. A chosen
        // ECG image only while the rhythm still fits it.
        var image = monitorPopup.image || res && (res.image || res.images[0] && res.images[0].key) || null;
        if (image && type === 'ECG' && INV && !INV.ecgImageFits(image, state.rhythm)) image = null;
        var images = !monitorPopup.image && res && res.images.length > 1 ? res.images : null;
        // A 12-lead drawn from the rhythm and rate at the moment the result was taken (not under a
        // report the facilitator typed, which the drawing might contradict).
        var live12 = !image && type === 'ECG' && !ct && res && res.live12 ? {
          rhythm: state.rhythm,
          hr: state.vitals ? state.vitals.hr : null
        } : null;
        // A course image the controller copies to the session can arrive just after its result:
        // remember it, and the effect below adds it to the card once it is registered.
        pendingImage.current = null;
        if (image && !(INV && INV.imageFor(image))) {
          if (String(image).startsWith('course:')) pendingImage.current = image;
          image = null;
        }
        setViewImage(null);
        setInvToast({
          title: title,
          content: content,
          image: image,
          images: images,
          live12: live12,
          urine: res ? res.urine : null,
          hideReport: !!monitorPopup.hideReport,
          gas: !!(ct && _typeof(ct) === 'object' && ct.__vbg) || type === 'VBG' && !ct && !!(scenario && scenario.vbg)
        });
      }
    }, [monitorPopup, scenario]);
    useEffect(function () {
      var key = pendingImage.current;
      if (!key || !(INV && INV.imageFor(key))) return;
      pendingImage.current = null;
      setInvToast(function (t) {
        return t && !t.image ? _objectSpread(_objectSpread({}, t), {}, {
          image: key
        }) : t;
      });
    }, [courseImageTick]);

    // A tap inside the embedded defib or ventilator (iframes) never reaches this page, so the
    // device pages post a message on their first touch and the monitor's sound is enabled from
    // it (the child frame's gesture also activates this page). Without it, a team working only on
    // the hosted defib had no sound, with the "Tap to Enable Sound" card hidden behind it.
    var enableAudioRef = useRef(null);
    useEffect(function () {
      var onMsg = function onMsg(e) {
        if (e.origin !== window.location.origin || !e.data || e.data.type !== 'wmebem-device-gesture') return;
        if (enableAudioRef.current) enableAudioRef.current();
      };
      window.addEventListener('message', onMsg);
      return function () {
        return window.removeEventListener('message', onMsg);
      };
    }, []);
    // The arrest view's status: SHOCK DELIVERED for three seconds after a shock (timed from
    // when THIS screen saw it, so the controller's clock does not matter), not for as long as
    // the screen flash happens to be red.
    var lastShockAt = state.defib ? state.defib.lastShockAt : null;
    var seenShockRef = useRef(lastShockAt);
    var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      shockShownAt = _useState18[0],
      setShockShownAt = _useState18[1];
    useEffect(function () {
      if (!lastShockAt || lastShockAt === seenShockRef.current) {
        seenShockRef.current = lastShockAt;
        return;
      }
      seenShockRef.current = lastShockAt;
      setShockShownAt(Date.now());
      var id = setTimeout(function () {
        return setShockShownAt(null);
      }, 3000);
      return function () {
        return clearTimeout(id);
      };
    }, [lastShockAt]);

    // ---- WAVE 5 / ITEM 1: SESSION-COMPLETE STATE -----------------------------------------
    // The monitor used to render a bare black div when the facilitator pressed Finish, so the
    // trainees' screen simply went blank with no explanation — no crash, no console error, just
    // nothing. `isFinished` already travels in the sync payload (set by STOP_SIM, carried by
    // SYNC_FROM_MASTER), so this state is reused rather than invented.
    //
    // ASSESSOR-ONLY BOUNDARY (Wave 3 / B4). This card is PATIENT-FACING. It deliberately shows
    // no outcome, no diagnosis, no score, no rhythm and no conversion history — exactly like the
    // rest of the monitor, which never receives rhythmEvent/lastConversion at all. It says only
    // that the session has ended and to turn to the facilitator for the debrief.
    if (state.isFinished) {
      return /*#__PURE__*/React.createElement("div", {
        className: "h-full w-full bg-black text-white flex items-center justify-center p-6",
        role: "status",
        "aria-live": "polite"
      }, /*#__PURE__*/React.createElement("div", {
        className: "max-w-xl w-full bg-slate-900 border border-slate-700 rounded-lg shadow-2xl p-8 text-center animate-fadeIn"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "check-circle",
        className: "w-14 h-14 text-emerald-500 mx-auto mb-4"
      }), /*#__PURE__*/React.createElement("h1", {
        className: "text-3xl font-bold tracking-wide mb-2"
      }, "Simulation complete"), /*#__PURE__*/React.createElement("p", {
        className: "text-slate-300 text-lg mb-4"
      }, "This session has ended. The monitor is no longer live."), /*#__PURE__*/React.createElement("p", {
        className: "text-slate-400 text-sm"
      }, "Please turn to your facilitator \u2014 the debrief happens with them, not on this screen."), /*#__PURE__*/React.createElement(FinishedActions, {
        onRestart: onRestart
      }), /*#__PURE__*/React.createElement("div", {
        className: "mt-6 pt-4 border-t border-slate-800 text-xs text-slate-400 font-mono uppercase tracking-widest"
      }, "Monitor standby")));
    }
    var handleEnableAudio = function handleEnableAudio() {
      requestWakeLock();
      var result = enableAudio();
      // Hidden only once the sound has really started; if the browser still refuses, the button
      // stays so the next tap can try again.
      if (result && typeof result.then === 'function') result.then(function (ok) {
        return setAudioEnabled(ok !== false);
      })["catch"](function () {
        return setAudioEnabled(false);
      });else setAudioEnabled(true);
    };
    enableAudioRef.current = audioEnabled ? null : handleEnableAudio;
    var isPaeds = scenario && (scenario.ageRange === 'Paediatric' || scenario.wetflag);
    var thresholds = window.getAlarmThresholds && window.getAlarmThresholds((_scenario$patientAge = scenario === null || scenario === void 0 ? void 0 : scenario.patientAge) !== null && _scenario$patientAge !== void 0 ? _scenario$patientAge : 40) || {
      hr: {
        low: 40,
        high: 130
      },
      rr: {
        low: 8,
        high: 30
      },
      spO2: 90
    };
    var tileCount = 4 + (hasArtLine ? 1 : 0) + (etco2Enabled ? 1 : 0);
    var denseTiles = tileCount >= 5; // smaller type so the numbers fit a tablet-width tile
    // A pulseless ORGANISED rhythm (PEA, pulseless VT, agonal) is held at HR 0 but still draws
    // complexes; a real monitor counts them, so the tile shows the rate that is drawn (the
    // same number the defib shows). VF and asystole have no QRS to count and are unchanged.
    var hrShown = function () {
      var RG = window.RHYTHMS;
      if (!RG || !RG.isPulseless(rhythm) || vitals.hr > 0) return vitals.hr;
      var q = RG.displayRate(rhythm, vitals.hr);
      return q === null ? vitals.hr : q;
    }();
    // VF and asystole have no QRS to count: the HR tile reads '---' in red, as the defib does
    // (pulseless organised rhythms still show the rate that is drawn, above).
    var hrNoCount = function () {
      var RG = window.RHYTHMS;
      return !!(RG && RG.isPulseless(rhythm) && RG.displayRate(rhythm, vitals.hr) === null);
    }() || !!(state.noise && state.noise.leadoff && !sSpo2); // lead off and no pleth to count from
    // A badly damped arterial line reads wrong, exactly as a real one does: underdamped
    // overestimates systolic, overdamped underestimates it; the mean stays the same.
    var abpShown = function () {
      var b = window.RHYTHMS && window.RHYTHMS.artDisplayBias ? window.RHYTHMS.artDisplayBias(state.noise && state.noise.art) : {
        sys: 0,
        dia: 0
      };
      if (!(vitals.bpSys > 0) || window.RHYTHMS && window.RHYTHMS.isPulseless(rhythm)) return {
        sys: vitals.bpSys,
        dia: vitals.bpDia
      };
      return {
        sys: Math.round(vitals.bpSys + b.sys),
        dia: Math.max(0, Math.round(vitals.bpDia + b.dia))
      };
    }();
    var shortLandscapeCols = function shortLandscapeCols() {
      return tileCount === 4 ? '[@media(orientation:landscape)_and_(max-height:500px)]:grid-cols-4' : tileCount === 5 ? '[@media(orientation:landscape)_and_(max-height:500px)]:grid-cols-5' : '[@media(orientation:landscape)_and_(max-height:500px)]:grid-cols-6';
    };
    var getGridCols = function getGridCols() {
      var count = tileCount;
      if (count === 4) return 'md:grid-cols-4';
      if (count === 5) return 'md:grid-cols-5';
      return 'md:grid-cols-6';
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "h-full w-full flex flex-col bg-black text-white transition-colors duration-200 ".concat(flash === 'red' ? 'flash-red' : flash === 'green' ? 'flash-green' : '', " relative overflow-hidden")
    }, syncProblem && /*#__PURE__*/React.createElement("div", {
      role: "alert",
      className: "absolute top-0 inset-x-0 z-[130] bg-red-950/95 border-b border-red-500 px-4 py-2 text-center text-sm font-bold text-red-100 shadow-lg"
    }, /*#__PURE__*/React.createElement("span", null, "Disconnected from live session."), syncStatus.message && /*#__PURE__*/React.createElement("span", {
      className: "ml-2 font-normal text-red-200"
    }, syncStatus.message)), !audioEnabled && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: handleEnableAudio,
      "data-testid": "enable-sound",
      className: "absolute top-0.5 left-1/2 -translate-x-1/2 z-[140] min-h-[44px] px-4 rounded-xl bg-slate-800/95 border border-sky-500 text-white font-bold shadow-lg flex items-center gap-2 whitespace-nowrap ".concat(shownView === 'monitor' ? 'text-base max-md:text-sm' : 'text-sm')
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "volume-2",
      className: "w-5 h-5 text-sky-400"
    }), " Tap to Enable Sound"), function () {
      // The result card. With an image it is wider (a 12-lead needs the width) and the
      // image opens full screen when tapped; the credit sits under it in small print. If the
      // image cannot load (offline before it was fetched), the card shows the written report.
      // Several pictures (a scan's windows): the chosen one is shown big, the rest as tabs.
      var pics = invToast && invToast.images && invToast.images.length > 1 ? invToast.images : null;
      var shownKey = pics ? (pics[invToast.imgIdx || 0] || pics[0]).key : invToast ? invToast.image : null;
      var img = shownKey && INV ? INV.imageFor(shownKey) : null;
      var live12 = invToast && !img ? invToast.live12 : null;
      var urine = invToast && !img ? invToast.urine : null;
      var wide = !!img || !!live12;
      return /*#__PURE__*/React.createElement("div", {
        className: "absolute top-4 right-4 z-[70] transition-all duration-500 ".concat(invToast ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0 pointer-events-none', " ").concat(viewImage || viewEcg ? 'hidden' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-slate-800 border-l-4 border-purple-500 rounded shadow-2xl p-3 sm:p-4 max-w-[92vw] ".concat(wide ? live12 || img.modality === 'ECG' ? 'w-[760px]' : 'w-[520px]' : invToast && invToast.gas ? 'w-[30rem] xl:w-[32rem]' : 'w-96 xl:w-[30rem] 2xl:w-[36rem]'),
        "data-testid": "inv-result"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex justify-between items-start mb-2"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "text-purple-400 font-bold uppercase text-base md:text-lg flex items-center gap-2"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "activity",
        className: "w-5 h-5"
      }), " ", invToast === null || invToast === void 0 ? void 0 : invToast.title, " Result"), /*#__PURE__*/React.createElement("button", {
        "aria-label": "Dismiss investigation result",
        "data-testid": "inv-result-close",
        onClick: function onClick() {
          setInvToast(null);
          setViewImage(null);
        },
        className: "-mt-3 -mr-3 min-w-[44px] min-h-[44px] flex items-center justify-center rounded text-slate-400 hover:text-white hover:bg-slate-700/60 pointer-events-auto"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "x",
        className: "w-5 h-5"
      }))), pics && img && /*#__PURE__*/React.createElement("div", {
        className: "flex flex-wrap gap-1.5 mb-2",
        role: "group",
        "aria-label": "Scan views",
        "data-testid": "inv-image-tabs"
      }, pics.map(function (p, i) {
        return /*#__PURE__*/React.createElement("button", {
          key: p.key,
          type: "button",
          "aria-pressed": (invToast.imgIdx || 0) === i,
          onClick: function onClick() {
            return setInvToast(function (t) {
              return t ? _objectSpread(_objectSpread({}, t), {}, {
                imgIdx: i
              }) : t;
            });
          },
          className: "min-h-[36px] px-3 rounded text-sm font-bold border ".concat((invToast.imgIdx || 0) === i ? 'bg-purple-600 border-purple-400 text-white' : 'bg-slate-700 border-slate-600 text-slate-200 hover:bg-slate-600')
        }, p.label);
      })), img && /*#__PURE__*/React.createElement("figure", {
        className: "mb-2"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return setViewImage(shownKey);
        },
        className: "block w-full bg-black rounded overflow-hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-400",
        "aria-label": "Open the ".concat(img.modality === 'ECG' ? '12-lead ECG' : invToast.title, " image full screen")
      }, /*#__PURE__*/React.createElement("img", {
        key: shownKey,
        src: img.loop || img.src,
        alt: img.modality === 'ECG' ? '12-lead ECG' : "".concat(invToast.title, " image"),
        className: "w-full object-contain ".concat(img.modality === 'ECG' ? 'max-h-[42vh] bg-white' : 'max-h-[48vh]'),
        "data-testid": "inv-image",
        onError: function onError(e) {
          if (img.loop && !e.currentTarget.src.endsWith(img.src)) {
            e.currentTarget.src = img.src;
            return;
          }
          setInvToast(function (t) {
            return t && (t.image === shownKey || t.images) ? _objectSpread(_objectSpread({}, t), {}, {
              image: null,
              images: null,
              hideReport: false
            }) : t;
          });
        }
      })), /*#__PURE__*/React.createElement("figcaption", {
        className: "text-[10px] text-slate-400 mt-1 leading-tight"
      }, "Tap to enlarge. Image: ", INV.creditText(img), ".")), live12 && /*#__PURE__*/React.createElement("figure", {
        className: "mb-2"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return setViewEcg(live12);
        },
        className: "block w-full bg-white rounded overflow-hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-400",
        "aria-label": "Open the 12-lead ECG full screen"
      }, /*#__PURE__*/React.createElement(Live12Lead, {
        rhythm: live12.rhythm,
        hr: live12.hr,
        scenario: scenario,
        className: "w-full max-h-[42vh] bg-white",
        testId: "inv-ecg-live"
      })), /*#__PURE__*/React.createElement("figcaption", {
        className: "text-[10px] text-slate-400 mt-1 leading-tight"
      }, "Tap to enlarge. Recorded from the patient's rhythm when the ECG was taken.")), urine && /*#__PURE__*/React.createElement("div", {
        className: "mb-2"
      }, /*#__PURE__*/React.createElement(UrineDipstick, {
        urine: urine
      })), !((img || live12) && invToast.hideReport) && !urine && (invToast === null || invToast === void 0 ? void 0 : invToast.content) && /*#__PURE__*/React.createElement("div", {
        className: "text-white text-base md:text-lg font-medium leading-relaxed whitespace-pre-line"
      }, invToast === null || invToast === void 0 ? void 0 : invToast.content)));
    }(), viewImage && INV && INV.imageFor(viewImage) && /*#__PURE__*/React.createElement(Modal, {
      label: "Investigation image",
      onClose: function onClose() {
        return setViewImage(null);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-black/95 flex flex-col items-center justify-center p-3 w-[96vw] h-[94vh]",
      onClick: function onClick() {
        return setViewImage(null);
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: INV.imageFor(viewImage).loop || INV.imageFor(viewImage).src,
      onError: function onError(e) {
        var im = INV.imageFor(viewImage);
        if (im.loop && !e.currentTarget.src.endsWith(im.src)) e.currentTarget.src = im.src;
      },
      alt: "Investigation image, full screen",
      className: "max-w-full max-h-[86vh] object-contain bg-white",
      "data-testid": "inv-image-full"
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-400 mt-2"
    }, "Tap to close. Image: ", INV.creditText(INV.imageFor(viewImage)), "."))), viewEcg && /*#__PURE__*/React.createElement(Modal, {
      label: "12-lead ECG",
      onClose: function onClose() {
        return setViewEcg(null);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-black/95 flex flex-col items-center justify-center p-3 w-[96vw] h-[94vh]",
      onClick: function onClick() {
        return setViewEcg(null);
      }
    }, /*#__PURE__*/React.createElement(Live12Lead, {
      rhythm: viewEcg.rhythm,
      hr: viewEcg.hr,
      scenario: scenario,
      className: "bg-white rounded max-w-full max-h-[86vh]",
      testId: "inv-ecg-live-full"
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-400 mt-2"
    }, "Tap to close."))), show12Lead && /*#__PURE__*/React.createElement(Modal, {
      label: "12-lead analysis",
      onClose: function onClose() {
        return setShow12Lead(false);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-black/90 flex flex-col items-center justify-center p-4 animate-fadeIn"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "text-white font-mono text-xl mb-2"
    }, "12-LEAD ANALYSIS (Tap to Close)"), scenarioEcgImage ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
      src: INV.imageFor(scenarioEcgImage).src,
      alt: "12-lead ECG",
      className: "bg-white rounded shadow-lg max-w-full max-h-[78vh] cursor-pointer",
      onClick: function onClick() {
        return setShow12Lead(false);
      },
      "data-testid": "ecg-12lead-image"
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-400 mt-2"
    }, "A real 12-lead ECG. Image: ", INV.creditText(INV.imageFor(scenarioEcgImage)), ".")) : /*#__PURE__*/React.createElement("canvas", {
      ref: canvasRef,
      width: "1000",
      height: "640",
      className: "bg-white rounded shadow-lg max-w-full max-h-[80vh] cursor-pointer",
      onClick: function onClick() {
        return setShow12Lead(false);
      }
    }))), (defibHere || ventHere) && !switcherInline && /*#__PURE__*/React.createElement(ScreenSwitcher, {
      options: switchOptions,
      value: shownView,
      onChange: setFrontView
    }), arrestPanelOpen && !defibHere && /*#__PURE__*/React.createElement("div", {
      className: "absolute inset-0 z-[100] bg-black flex flex-col animate-fadeIn"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 border-b border-slate-700 p-2 flex justify-between items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-slate-300 font-bold uppercase tracking-wider flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "zap",
      className: "text-red-500"
    }), " Manual Defibrillator"), /*#__PURE__*/React.createElement("div", {
      className: "text-red-500 font-mono font-bold animate-pulse text-xl"
    }, "MANUAL DEFIBRILLATOR MODE"), /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400"
    }, new Date().toLocaleTimeString('en-GB'))), /*#__PURE__*/React.createElement("div", {
      className: "flex-grow min-h-0 relative bg-black grid ".concat(etco2Enabled ? 'grid-rows-3' : 'grid-rows-2')
    }, /*#__PURE__*/React.createElement("div", {
      className: "relative min-h-0 border-b border-slate-800"
    }, /*#__PURE__*/React.createElement(ECGMonitor, {
      noise: state.noise,
      rhythmType: rhythm,
      hr: vitals.hr,
      rr: 0,
      spO2: 0,
      isPaused: false,
      showTraces: true,
      showPleth: false,
      showResp: false,
      showEtco2: false,
      showArt: false,
      isCPR: cprInProgress,
      className: "h-full",
      rhythmLabel: "LEAD II"
    })), /*#__PURE__*/React.createElement("div", {
      className: "relative min-h-0 ".concat(etco2Enabled ? 'border-b border-slate-800' : '')
    }, /*#__PURE__*/React.createElement(ECGMonitor, {
      noise: state.noise,
      rhythmType: rhythm,
      hr: vitals.hr,
      rr: 0,
      spO2: 0,
      isPaused: false,
      showTraces: true,
      showPleth: false,
      showResp: false,
      showEtco2: false,
      showArt: false,
      isCPR: cprInProgress,
      className: "h-full",
      rhythmLabel: "PADS"
    })), etco2Enabled && /*#__PURE__*/React.createElement("div", {
      className: "relative min-h-0",
      "data-testid": "arrest-capnogram"
    }, /*#__PURE__*/React.createElement(ECGMonitor, {
      noise: state.noise,
      rhythmType: rhythm,
      hr: vitals.hr,
      rr: vitals.rr,
      etco2: vitals.etco2,
      isPaused: false,
      showTraces: true,
      showEcg: false,
      showPleth: false,
      showResp: false,
      showEtco2: true,
      showArt: false,
      isCPR: cprInProgress,
      cprBadge: false,
      co2Pathology: etco2Pathology || 'normal',
      co2Severity: co2Severity,
      ventilating: capnoVentilating,
      className: "h-full"
    }), /*#__PURE__*/React.createElement("div", {
      className: "absolute bottom-1 right-2 z-20 font-mono text-purple-400 font-bold text-2xl"
    }, "ETCO2 ", Number.isFinite(vitals.etco2) ? vitals.etco2.toFixed(1) : '--', " ", /*#__PURE__*/React.createElement("span", {
      className: "text-xs text-purple-300/80"
    }, "kPa")))), /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-900 p-4 border-t border-slate-700 grid grid-cols-4 gap-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-black border border-slate-700 rounded p-2 text-center flex flex-col justify-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400 text-xs uppercase mb-1"
    }, "Energy Select"), /*#__PURE__*/React.createElement("div", {
      className: "text-3xl font-mono text-yellow-500 font-bold"
    }, state.defib && state.defib.energy || window.RHYTHMS.recommendedEnergy(scenario === null || scenario === void 0 || (_scenario$wetflag = scenario.wetflag) === null || _scenario$wetflag === void 0 ? void 0 : _scenario$wetflag.weight, scenario === null || scenario === void 0 ? void 0 : scenario.patientAge), " J")), /*#__PURE__*/React.createElement("div", {
      className: "bg-black border border-slate-700 rounded p-2 text-center flex flex-col justify-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400 text-xs uppercase mb-1"
    }, "Status"), /*#__PURE__*/React.createElement("div", {
      className: "text-xl font-mono text-white font-bold"
    }, function () {
      var d = state.defib || {};
      if (flash === 'yellow') return 'CHARGING...';
      if (d.charged) return "CHARGED".concat(d.chargeEnergy ? " ".concat(d.chargeEnergy, " J") : '');
      if (shockShownAt) return 'SHOCK DELIVERED';
      return 'READY';
    }())), /*#__PURE__*/React.createElement("div", {
      className: "col-span-2 flex items-center justify-end gap-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400 text-sm uppercase font-bold mr-4"
    }, "CPR Timer: ", /*#__PURE__*/React.createElement("span", {
      className: "text-white text-xl font-mono"
    }, Math.floor(state.cycleTimer / 60), ":", (state.cycleTimer % 60).toString().padStart(2, '0')))))), /*#__PURE__*/React.createElement("div", {
      className: "flex-grow flex flex-col p-2 md:p-3 gap-2 h-full relative z-10 ".concat(isPaeds && showWetflag && scenario !== null && scenario !== void 0 && scenario.wetflag ? 'md:pr-52' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-grow relative border border-slate-800 rounded overflow-hidden flex flex-col min-h-0 bg-black"
    }, hasMonitoring ? /*#__PURE__*/React.createElement(ECGMonitor, {
      noise: state.noise,
      rhythmType: rhythm,
      hr: vitals.hr,
      rr: vitals.rr,
      spO2: vitals.spO2,
      etco2: vitals.etco2,
      isPaused: false,
      showTraces: true,
      showEcg: sEcg,
      showPleth: sSpo2,
      showResp: sEcg
      // A removed ECG/SpO2 sensor leaves its lane in place and
      // BLANK ("leads off" / "no probe"), matching the numeric
      // tiles, which also stay put and read "Off".
      ,
      reserveLanes: ['ecg', 'pleth', 'resp'],
      showEtco2: etco2Enabled,
      showArt: hasArtLine,
      isCPR: cprInProgress,
      co2Pathology: etco2Pathology || 'normal',
      co2Severity: co2Severity,
      ventilating: capnoVentilating,
      className: "h-full",
      rhythmLabel: "ECG"
    }) : /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center h-full text-slate-700 font-mono text-xl animate-pulse"
    }, "NO SENSOR DETECTED"), /*#__PURE__*/React.createElement("div", {
      className: "absolute bottom-2 right-2 z-20 flex items-center gap-1 opacity-60 hover:opacity-100 transition-opacity"
    }, /*#__PURE__*/React.createElement("span", {
      title: wakeState === 'on' ? 'This screen will stay on while the monitor is open.' : wakeState === 'unsupported' ? 'This browser cannot keep the screen awake. Set the tablet\'s auto-lock to Never for the session.' : 'Screen may sleep. Tap the screen (or Full screen) to try again, or set auto-lock to Never.',
      className: "hidden sm:flex items-center gap-1 px-1.5 py-1 rounded border text-[9px] font-bold uppercase tracking-wider ".concat(wakeState === 'on' ? 'border-slate-700 text-slate-400' : 'border-amber-700 text-amber-400')
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "sun",
      className: "w-3 h-3"
    }), " ", wakeState === 'on' ? 'Awake' : 'May sleep'), fsSupported && /*#__PURE__*/React.createElement("button", {
      onClick: toggleFullscreen,
      "aria-label": isFullscreen ? 'Exit full screen' : 'Full screen',
      title: isFullscreen ? 'Exit full screen' : 'Full screen',
      className: "p-1.5 rounded border border-slate-700 bg-black/60 text-slate-400 hover:text-white"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: isFullscreen ? 'minimize' : 'maximize',
      className: "w-4 h-4"
    }))), ((_state$monitorTimer = state.monitorTimer) === null || _state$monitorTimer === void 0 ? void 0 : _state$monitorTimer.visible) && /*#__PURE__*/React.createElement("div", {
      className: "absolute top-2 right-2 bg-black/50 text-slate-300 font-mono font-bold text-4xl md:text-6xl px-4 py-2 rounded border border-slate-700 shadow-2xl"
    }, Math.floor(state.monitorTimer.time / 60).toString().padStart(2, '0'), ":", (state.monitorTimer.time % 60).toString().padStart(2, '0'))), /*#__PURE__*/React.createElement("div", {
      "data-testid": "obs-tiles",
      className: "flex-none grid grid-cols-2 ".concat(getGridCols(), " auto-rows-fr gap-2 ").concat(tileCount > 4 ? 'h-[46vh]' : 'h-[38vh]', " md:h-[28vh] ").concat(shortLandscapeCols(), " [@media(orientation:landscape)_and_(max-height:500px)]:h-[32vh]")
    }, /*#__PURE__*/React.createElement(VitalDisplay, {
      label: "Heart Rate",
      value: hrShown,
      prev: prevVitals.hr,
      unit: "bpm",
      alert: hrNoCount || hrShown > thresholds.hr.high || hrShown < thresholds.hr.low,
      visible: sEcg,
      isMonitor: true,
      hideTrends: true,
      dense: denseTiles,
      noCount: hrNoCount
    }), /*#__PURE__*/React.createElement("div", {
      className: "relative h-full min-w-0"
    }, /*#__PURE__*/React.createElement(VitalDisplay, {
      label: "NIBP",
      value: nibp.sys,
      value2: nibp.dia,
      unit: "mmHg",
      alert: nibp.sys && nibp.sys < (thresholds.bpSys || 90),
      visible: sNibp || !!nibp.sys,
      isMonitor: true,
      hideTrends: true,
      isNIBP: true,
      lastNIBP: nibp.lastTaken,
      onClick: sNibp ? triggerNIBP : undefined,
      note: sNibp ? null : 'cuff off',
      dense: denseTiles,
      reserveBottom: sNibp
    }), sNibp && /*#__PURE__*/React.createElement("div", {
      className: "absolute bottom-1 right-1 left-1 flex gap-1 lg:gap-2 z-20 px-1",
      "data-testid": "nibp-buttons"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick(e) {
        e.stopPropagation();
        nibp.inflating && sim.stopNIBP ? sim.stopNIBP() : triggerNIBP();
      },
      className: "bg-slate-800 hover:bg-slate-700 text-slate-300 text-[11px] lg:text-sm font-bold px-0.5 py-2 rounded border border-slate-600 uppercase lg:tracking-wide transition-colors shadow-lg flex-1 min-w-0 h-12 max-md:h-9 [@media(orientation:landscape)_and_(max-height:500px)]:h-8 [@media(orientation:landscape)_and_(max-height:500px)]:py-1 truncate"
    }, nibp.inflating ? 'Stop' : 'Cycle'), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick(e) {
        e.stopPropagation();
        toggleNIBPMode();
      },
      className: "text-[11px] lg:text-sm font-bold px-0.5 py-2 rounded border uppercase lg:tracking-wide transition-colors shadow-lg h-12 max-md:h-9 [@media(orientation:landscape)_and_(max-height:500px)]:h-8 [@media(orientation:landscape)_and_(max-height:500px)]:py-1 flex-1 min-w-0 max-w-[80px] truncate ".concat(nibp.mode === 'auto' ? 'bg-emerald-900/80 border-emerald-500 text-emerald-400' : 'bg-slate-800 border-slate-600 text-slate-400')
    }, "Auto"))), /*#__PURE__*/React.createElement(VitalDisplay, {
      label: "SpO2",
      value: vitals.spO2,
      prev: prevVitals.spO2,
      unit: "%",
      alert: vitals.spO2 < thresholds.spO2,
      visible: sSpo2,
      isMonitor: true,
      hideTrends: true,
      dense: denseTiles
    }), hasArtLine && /*#__PURE__*/React.createElement(VitalDisplay, {
      label: "ABP",
      value: abpShown.sys,
      value2: abpShown.dia,
      unit: "mmHg",
      alert: abpShown.sys < (thresholds.bpSys || 90),
      visible: true,
      isMonitor: true,
      hideTrends: true,
      dense: denseTiles
    }), /*#__PURE__*/React.createElement(VitalDisplay, {
      label: "Resp Rate",
      value: vitals.rr,
      prev: prevVitals.rr,
      unit: "/min",
      alert: vitals.rr > thresholds.rr.high || vitals.rr < thresholds.rr.low,
      visible: sEcg || !!etco2Enabled,
      isMonitor: true,
      hideTrends: true,
      dense: denseTiles
    }), etco2Enabled && /*#__PURE__*/React.createElement(VitalDisplay, {
      label: "ETCO2",
      value: vitals.etco2,
      prev: prevVitals.etco2,
      unit: "kPa",
      alert: vitals.etco2 < 4.0 || vitals.etco2 > 6.5,
      visible: etco2Enabled,
      isMonitor: true,
      hideTrends: true,
      dense: denseTiles
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex-none grid grid-cols-2 gap-2 mt-1"
    }, function () {
      var tempOn = sTemp && Number.isFinite(vitals.temp);
      var bm = poc.bm || null;
      var cell = function cell(label, value, unit, sub, alert) {
        return /*#__PURE__*/React.createElement("div", {
          className: "bg-slate-950 border rounded px-2 py-1 flex items-baseline justify-between ".concat(alert ? 'border-amber-600' : 'border-slate-800')
        }, /*#__PURE__*/React.createElement("span", {
          className: "text-[11px] md:text-xs lg:text-sm uppercase tracking-widest text-slate-400 font-bold"
        }, label, sub ? /*#__PURE__*/React.createElement("span", {
          className: "ml-1 text-[10px] lg:text-xs text-slate-400 normal-case tracking-normal"
        }, sub) : null), /*#__PURE__*/React.createElement("span", {
          className: "font-mono font-bold text-xl md:text-3xl 2xl:text-4xl ".concat(value === null ? 'text-slate-700' : alert ? 'text-amber-400' : 'text-sky-300')
        }, value === null ? '--' : value, value !== null && unit ? /*#__PURE__*/React.createElement("span", {
          className: "text-[11px] md:text-xs lg:text-sm text-slate-400 ml-1"
        }, unit) : null));
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, cell('Temp', tempOn ? vitals.temp.toFixed(1) : null, "\xB0C", sTemp ? null : 'no probe', tempOn && (vitals.temp < 35 || vitals.temp >= 38.5)), cell('Glucose', bm && Number.isFinite(bm.value) ? bm.value.toFixed(1) : null, 'mmol/L', bm ? bm.clock : 'no sample', !!(bm && Number.isFinite(bm.value) && (bm.value < 4 || bm.value > 11))));
    }()), /*#__PURE__*/React.createElement("div", {
      className: "flex-none h-14 md:h-16 bg-slate-950 border border-slate-800 rounded flex overflow-hidden shadow-lg mt-1"
    }, (defibHere || ventHere) && switcherInline && /*#__PURE__*/React.createElement(ScreenSwitcher, {
      inline: true,
      options: switchOptions,
      value: shownView,
      onChange: setFrontView
    }), /*#__PURE__*/React.createElement(InvBtn, {
      label: "12-Lead",
      icon: "activity",
      onClick: function onClick() {
        setInvToast(null);
        setShow12Lead(true);
        if (sim.sendDeviceEvent) sim.sendDeviceEvent('REQUEST_12LEAD', {});
      },
      loading: loadingInvestigations === null || loadingInvestigations === void 0 ? void 0 : loadingInvestigations['ECG']
    }), [['VBG', 'droplet', 'VBG'], ['ABG', 'droplet', 'ABG'], ['CXR', 'image', 'X-ray'], ['Urine', 'flask-conical', 'Urine'], ['POCUS', 'waves', 'POCUS'], ['CT Head', 'scan', 'CT']].map(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 3),
        label = _ref11[0],
        icon = _ref11[1],
        type = _ref11[2];
      return /*#__PURE__*/React.createElement(InvBtn, {
        key: type,
        label: label,
        icon: icon,
        onClick: function onClick() {
          setShow12Lead(false);
          revealInvestigation(type);
          if (sim.sendDeviceEvent) sim.sendDeviceEvent('INVESTIGATION', {
            type: type
          });
        },
        loading: loadingInvestigations === null || loadingInvestigations === void 0 ? void 0 : loadingInvestigations[type]
      });
    }))), isPaeds && showWetflag && scenario.wetflag && /*#__PURE__*/React.createElement("div", {
      className: "absolute top-0 right-0 h-full w-48 bg-slate-900/95 backdrop-blur border-l border-slate-700 p-2 flex flex-col gap-2 shadow-2xl z-40"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-purple-900/40 border border-purple-500/50 p-2 rounded mb-2"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-purple-400 font-bold text-center text-sm"
    }, "WETFLAG"), /*#__PURE__*/React.createElement("div", {
      className: "text-center text-white font-mono text-xl font-bold"
    }, scenario.wetflag.weight, "kg"), /*#__PURE__*/React.createElement("div", {
      className: "text-center bg-slate-800 text-white font-bold text-sm mt-1 py-1 rounded"
    }, "Age: ", window.shortAge ? window.shortAge(scenario.patientAge) : window.formatAge ? window.formatAge(scenario.patientAge) : "".concat(scenario.patientAge, " yrs"))), /*#__PURE__*/React.createElement("div", {
      className: "flex-1 flex flex-col gap-1 overflow-y-auto"
    }, /*#__PURE__*/React.createElement(WetFlagItem, {
      label: "Energy",
      value: "".concat(scenario.wetflag.energy, "J")
    }), /*#__PURE__*/React.createElement(WetFlagItem, {
      label: "Tube",
      value: scenario.wetflag.tube
    }), /*#__PURE__*/React.createElement(WetFlagItem, {
      label: "Fluids",
      value: "".concat(scenario.wetflag.fluids, "ml")
    }), /*#__PURE__*/React.createElement(WetFlagItem, {
      label: "Loraz",
      value: "".concat(scenario.wetflag.lorazepam, "mg")
    }), /*#__PURE__*/React.createElement(WetFlagItem, {
      label: "Adren",
      value: "".concat(scenario.wetflag.adrenaline, "mcg")
    }), /*#__PURE__*/React.createElement(WetFlagItem, {
      label: "Gluc",
      value: "".concat(scenario.wetflag.glucose, "ml")
    }))));
  };
  var WetFlagItem = function WetFlagItem(_ref12) {
    var label = _ref12.label,
      value = _ref12.value;
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-2 rounded flex flex-col items-center justify-center"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-[10px] text-slate-400 uppercase font-bold"
    }, label), /*#__PURE__*/React.createElement("span", {
      className: "font-mono text-lg font-bold text-white"
    }, value));
  };

  // A patient screen. It joins with the session code only; the controller numbers it and chooses
  // what it shows (data/screens/screenspanel.js), and can change that at any time. An older link's
  // ?screen= is only where it starts.
  var MonitorContainer = function MonitorContainer(_ref13) {
    var sessionID = _ref13.sessionID,
      screen = _ref13.screen;
    var _window6 = window,
      Lucide = _window6.Lucide,
      useMyScreen = _window6.useMyScreen,
      ScreenNumberOverlay = _window6.ScreenNumberOverlay;
    var S = window.SimScreens;
    var sim = useSimulation(null, true, sessionID);
    // Console / test handle on the monitor's engine (read it, don't build on it).
    useEffect(function () {
      window.__monitorEngine = sim;
    });
    var _useState19 = useState(null),
      _useState20 = _slicedToArray(_useState19, 2),
      screenId = _useState20[0],
      setScreenId = _useState20[1];
    useEffect(function () {
      return S.claimScreenId(setScreenId);
    }, []);
    var mine = useMyScreen(sessionID, screenId);
    var role = mine.role || S.roleOf(screen);
    var parts = S.partsOf(role);
    // No patient from the controller yet (none chosen, or it was taken off): the screen stays blank
    // and waits, even once the controller has numbered it. This screen's own engine always has
    // default obs, so those must never be shown as a patient. A mistyped code stays here too.
    // "Restart monitor" on the finished card: back to a blank, waiting screen on the same code
    // until the controller starts the next scenario (the finished run no longer shows).
    var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      restarted = _useState22[0],
      setRestarted = _useState22[1];
    useEffect(function () {
      if (!sim.state.isFinished) setRestarted(false);
    }, [sim.state.isFinished]);
    // Before the controller's first START the scenario is being set up, so the patient screens stay
    // blank too (Jake: "keep the monitor blank until I actually click start"). `started` rides in the
    // synced defib object; a controller that does not send it counts as started.
    var settingUp = !!sim.state.liveSeen && !sim.state.isFinished && !!sim.state.defib && sim.state.defib.started === false;
    var waiting = !sim.state.liveSeen || restarted && !!sim.state.isFinished || settingUp;
    var _useState23 = useState(null),
      _useState24 = _slicedToArray(_useState23, 2),
      shows = _useState24[0],
      setShows = _useState24[1];
    // The embedded defib and ventilator pages live HERE, not inside MonitorScreen/DeviceScreen,
    // so a role change that adds or removes the monitor (which swaps those two) does not reload
    // a device that stays on this screen: a reload would stop pacing, drop a charge, and reset
    // the ventilator. Each screen view reports which devices it holds (onHost).
    var _useState25 = useState([]),
      _useState26 = _slicedToArray(_useState25, 2),
      host = _useState26[0],
      setHost = _useState26[1];
    var showsNow = waiting || !parts.includes(shows) ? parts[0] : shows;
    // What this screen is and shows, for its presence heartbeat (data/engine-sync.js).
    useEffect(function () {
      if (screenId) sim.dispatch({
        type: 'SET_LOCAL_SCREEN',
        payload: {
          id: screenId,
          role: role,
          shows: showsNow
        }
      });
    }, [screenId, role, showsNow]);
    // The number comes up on its own for a few seconds when the screen is first numbered and
    // whenever the controller changes what it shows, so the room sees which screen changed.
    var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      flashing = _useState28[0],
      setFlashing = _useState28[1];
    useEffect(function () {
      if (!mine.n) return;
      setFlashing(true);
      var t = setTimeout(function () {
        return setFlashing(false);
      }, 4000);
      return function () {
        return clearTimeout(t);
      };
    }, [mine.n, mine.role]);
    if (!sessionID) return null;
    var syncStatus = sim.state.syncStatus || {
      state: 'connecting',
      message: 'Connecting to live session…'
    };
    var syncProblem = ['unavailable', 'disconnected', 'error', 'degraded'].includes(syncStatus.state);
    var overlay = (mine.identify || flashing) && mine.n ? /*#__PURE__*/React.createElement(ScreenNumberOverlay, {
      n: mine.n,
      role: role
    }) : null;
    // The patient picture the controller chose to show (data/screens/patientstatus.js), on every screen
    // with a monitor, also while the scenario is still being set up (a handover before START).
    var picture = parts.includes('monitor') && window.PatientStatus ? /*#__PURE__*/React.createElement(window.PatientStatus.MonitorPicture, {
      state: sim.state
    }) : null;
    if (waiting) {
      return /*#__PURE__*/React.createElement("div", {
        className: "relative h-full flex flex-col items-center justify-center bg-black text-slate-400 gap-4 animate-fadeIn p-4 text-center",
        "data-testid": "screen-waiting"
      }, mine.n ? /*#__PURE__*/React.createElement("div", {
        className: "rounded-2xl px-8 font-black leading-none ".concat(S.numberColour(mine.n)),
        style: {
          fontSize: 'min(30vh, 30vw)'
        },
        "data-testid": "waiting-screen-number"
      }, mine.n) : /*#__PURE__*/React.createElement(Lucide, {
        icon: "wifi",
        className: "w-12 h-12 animate-pulse text-sky-500"
      }), mine.n && /*#__PURE__*/React.createElement("div", {
        className: "text-3xl font-bold text-white"
      }, "Screen ", mine.n), /*#__PURE__*/React.createElement("div", {
        className: "text-xl font-mono tracking-widest ".concat(syncProblem ? 'text-red-300' : '')
      }, syncProblem ? 'DISCONNECTED FROM LIVE SESSION' : settingUp ? 'SCENARIO BEING SET UP' : 'WAITING FOR CONTROLLER'), settingUp && !syncProblem && /*#__PURE__*/React.createElement("div", {
        className: "text-sm text-amber-200",
        "data-testid": "waiting-for-start"
      }, "The patient appears here when the controller presses START."), mine.n && !syncProblem && !settingUp && /*#__PURE__*/React.createElement("div", {
        className: "text-sm text-slate-300",
        "data-testid": "waiting-for-scenario"
      }, "Connected. The patient appears here when the controller starts a scenario."), /*#__PURE__*/React.createElement("div", {
        className: "bg-slate-900 px-4 py-2 rounded border border-slate-800 font-bold text-sky-500"
      }, "SESSION: ", sessionID), /*#__PURE__*/React.createElement("div", {
        className: "text-sm text-slate-400",
        "data-testid": "waiting-screen-role"
      }, "This screen: ", /*#__PURE__*/React.createElement("b", {
        className: "text-slate-200"
      }, S.ROLES[role].title), mine.n ? '' : ' (until the controller numbers it)'), /*#__PURE__*/React.createElement("div", {
        className: "text-xs text-slate-400 max-w-md"
      }, "The controller chooses what this screen shows, in ", /*#__PURE__*/React.createElement("b", null, "Screens"), ". Nothing needs doing here."), syncProblem && /*#__PURE__*/React.createElement("div", {
        role: "alert",
        className: "max-w-md px-4 text-center text-sm text-red-300"
      }, syncStatus.message || 'Check the Firebase connection and session permissions.'), !syncProblem && !sim.state.isFinished && picture, overlay);
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "h-full w-full relative"
    }, parts.includes('monitor') ? /*#__PURE__*/React.createElement(MonitorScreen, {
      key: "monitor",
      sim: sim,
      sessionID: sessionID,
      parts: parts,
      onShows: setShows,
      onHost: setHost,
      onRestart: function onRestart() {
        return setRestarted(true);
      }
    }) : /*#__PURE__*/React.createElement(DeviceScreen, {
      key: "devices",
      sim: sim,
      sessionID: sessionID,
      parts: parts,
      onShows: setShows,
      onHost: setHost,
      onRestart: function onRestart() {
        return setRestarted(true);
      }
    }), ['defib', 'vent'].map(function (k) {
      return host.includes(k) && parts.includes(k) && !sim.state.isFinished ? /*#__PURE__*/React.createElement(DeviceLayer, {
        key: k,
        kind: k,
        sessionID: sessionID,
        shown: showsNow === k
      }) : null;
    }), !sim.state.isFinished && picture, overlay);
  };
  window.DeviceScreen = DeviceScreen;
  window.MonitorScreen = MonitorScreen;
  window.MonitorContainer = MonitorContainer;
})();